module.exports = __webpack_public_path__ + "img/kitchen.977d8c1e.svg";